export const makeOverridableFactory = factory => {
  const overrides = {
    transform: null
  };

  // Create a base function explicitly typed as (...args: Parameters<F>) => ReturnType<F>
  const base = (...args) => {
    const original = factory(...args);
    return overrides.transform ? overrides.transform(original) : original;
  };

  // Merge extra methods onto the base function
  return Object.assign(base, {
    applyOverrides: transform => {
      const existing = overrides.transform;
      overrides.transform = existing ? result => transform(existing(result)) : transform;
    },
    resetOverrides: () => {
      overrides.transform = null;
    }
  });
};